export let NEDGIA_CONTACT = {
  WEB: 'https://www.nedgia.es/contacto/',
  PHONE_1: false, //'900 100 252'
  PHONE_2: false,
  FACEBOOK: 'facebook.com/nedgia.es/',
  TWITTER: '@nedgia',
  INSTAGRAM: 'nedgia_es',
}
